// import React, {useMemo} from 'react';
// import {useSelector} from 'react-redux';
// import _ from 'lodash';
// import {Activity, AlertCircle, CheckCircle2, Eye, EyeOff, Globe, RefreshCw, Signal, Wifi, WifiOff} from 'lucide-react';
// import {useSocket} from "../dashboard/SocketContext.jsx";
//
// export default function SocketStatus() {
//     // Récupérer les sites depuis Redux
//     const sites = useSelector(state => state.sites.items);
//     const {
//         isConnected,
//         socketId,
//         socketService,
//         activeSites = new Set(),
//         recentVisits = [],
//         sendHeartbeat
//     } = useSocket();
//
//     // Sécuriser les valeurs avec lodash
//     const safeActiveSites = _.isSet(activeSites) ? activeSites : new Set();
//     const safeRecentVisits = _.isArray(recentVisits) ? recentVisits : [];
//     const safeSocketId = _.isString(socketId) ? socketId : null;
//
//     // Formater les données des sites
//     const siteData = useMemo(() => {
//         try {
//             // Convertir les sites en tableau sécurisé
//             const safeSites = _.isArray(sites) ? sites : [];
//
//             // Filtrer pour ne garder que les sites avec surveillance active
//             const monitoredSites = safeSites.filter(site => {
//                 const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
//                 return siteKey && safeActiveSites.has(siteKey);
//             });
//
//             // Sites non surveillés
//             const unmonitoredSites = safeSites.filter(site => {
//                 const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
//                 return siteKey && !safeActiveSites.has(siteKey);
//             });
//
//             // Récupérer les noms des sites surveillés
//             const monitoredSiteNames = monitoredSites.map(site =>
//                 _.get(site, 'name', _.get(site, 'siteKey', 'Site inconnu'))
//             );
//
//             return {
//                 monitoredCount: monitoredSites.length,
//                 totalCount: safeSites.length,
//                 monitoredSites: monitoredSites,
//                 unmonitoredSites: unmonitoredSites,
//                 monitoredSiteNames,
//                 onlineCount: _.sumBy(monitoredSites, site =>
//                     _.toNumber(_.get(site, 'onlineVisitors', 0))
//                 )
//             };
//         } catch (error) {
//             console.error('Erreur formatage sites:', error);
//             return {
//                 monitoredCount: 0,
//                 totalCount: 0,
//                 monitoredSites: [],
//                 unmonitoredSites: [],
//                 monitoredSiteNames: [],
//                 onlineCount: 0
//             };
//         }
//     }, [sites, safeActiveSites]);
//
//     // Fonction pour joindre un site spécifique
//     const joinSite = async (siteKey) => {
//         if (socketService && socketService.joinSite) {
//             try {
//                 await socketService.joinSite(siteKey);
//             } catch (error) {
//                 console.error('Erreur rejoindre site:', error);
//             }
//         }
//     };
//
//     // Fonction pour quitter un site
//     const leaveSite = async (siteKey) => {
//         if (socketService && socketService.leaveSite) {
//             try {
//                 socketService.leaveSite(siteKey);
//             } catch (error) {
//                 console.error('Erreur quitter site:', error);
//             }
//         }
//     };
//
//     return (
//         <div className="fixed bottom-4 right-4 z-50">
//             <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 min-w-[320px] max-w-md">
//                 {/* En-tête */}
//                 <div className="flex items-center justify-between mb-4">
//                     <div className="flex items-center">
//                         <div className={`p-2 rounded-full mr-3 ${isConnected ? 'bg-green-100' : 'bg-red-100'}`}>
//                             {isConnected ? (
//                                 <Wifi className="h-5 w-5 text-green-600" />
//                             ) : (
//                                 <WifiOff className="h-5 w-5 text-red-600" />
//                             )}
//                         </div>
//                         <div>
//                             <h3 className="font-semibold text-gray-900">
//                                 Surveillance en temps réel
//                             </h3>
//                             <p className="text-sm text-gray-500">
//                                 {isConnected ? 'Connecté' : 'Déconnecté'}
//                             </p>
//                         </div>
//                     </div>
//                     <button
//                         onClick={sendHeartbeat}
//                         className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                         title="Tester la connexion"
//                         disabled={!isConnected}
//                     >
//                         <RefreshCw className={`h-4 w-4 ${isConnected ? 'text-gray-600' : 'text-gray-400'}`} />
//                     </button>
//                 </div>
//
//                 {/* État de connexion */}
//                 <div className={`px-3 py-2 rounded-lg mb-4 ${isConnected ? 'bg-green-50' : 'bg-red-50'}`}>
//                     <div className="flex items-center justify-between">
//                         <div className="flex items-center">
//                             {isConnected ? (
//                                 <CheckCircle2 className="h-4 w-4 text-green-600 mr-2" />
//                             ) : (
//                                 <AlertCircle className="h-4 w-4 text-red-600 mr-2" />
//                             )}
//                             <span className={`text-sm font-medium ${isConnected ? 'text-green-700' : 'text-red-700'}`}>
//                                 {isConnected ? 'Connexion active' : 'En attente de connexion'}
//                             </span>
//                         </div>
//                         <span className="text-xs text-gray-500 font-mono">
//                             {safeSocketId ? `ID: ${safeSocketId.substring(0, 8)}...` : 'N/A'}
//                         </span>
//                     </div>
//                 </div>
//
//                 {/* Statistiques de surveillance */}
//                 <div className="grid grid-cols-2 gap-3 mb-4">
//                     <div className="bg-blue-50 rounded-lg p-3">
//                         <div className="flex items-center justify-between">
//                             <div>
//                                 <p className="text-xs text-blue-700 mb-1">Sites total</p>
//                                 <p className="text-lg font-bold text-blue-900">
//                                     {siteData.totalCount}
//                                 </p>
//                             </div>
//                             <Globe className="h-5 w-5 text-blue-600 opacity-60" />
//                         </div>
//                     </div>
//
//                     <div className="bg-green-50 rounded-lg p-3">
//                         <div className="flex items-center justify-between">
//                             <div>
//                                 <p className="text-xs text-green-700 mb-1">Sites surveillés</p>
//                                 <p className="text-lg font-bold text-green-900">
//                                     {siteData.monitoredCount}
//                                 </p>
//                             </div>
//                             <Eye className="h-5 w-5 text-green-600 opacity-60" />
//                         </div>
//                     </div>
//                 </div>
//
//                 {/* Sites surveillés */}
//                 <div className="mb-4">
//                     <div className="flex items-center justify-between mb-3">
//                         <div className="flex items-center">
//                             <Globe className="h-4 w-4 text-blue-600 mr-2" />
//                             <span className="text-sm font-medium text-gray-900">
//                                 Sites surveillés ({siteData.monitoredCount}/{siteData.totalCount})
//                             </span>
//                         </div>
//                         <div className="flex items-center">
//                             <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse mr-1"></div>
//                             <span className="text-xs text-gray-500">
//                                 {siteData.onlineCount} en ligne
//                             </span>
//                         </div>
//                     </div>
//
//                     {siteData.monitoredCount > 0 ? (
//                         <div className="space-y-2 max-h-40 overflow-y-auto pr-2">
//                             {siteData.monitoredSites.slice(0, 5).map((site, index) => {
//                                 const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
//                                 const siteName = _.get(site, 'name', siteKey);
//                                 const onlineVisitors = _.toNumber(_.get(site, 'onlineVisitors', 0));
//                                 const todayVisits = _.toNumber(_.get(site, 'todayVisites', 0));
//
//                                 return (
//                                     <div key={`monitored-${siteKey}-${index}`}
//                                          className="flex items-center justify-between p-2 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors group">
//                                         <div className="flex-1 min-w-0">
//                                             <div className="flex items-center">
//                                                 <Signal className="h-3 w-3 text-green-500 mr-2 flex-shrink-0" />
//                                                 <span className="text-sm font-medium text-gray-900 truncate">
//                                                     {_.truncate(siteName, { length: 22 })}
//                                                 </span>
//                                             </div>
//                                             <div className="flex items-center text-xs text-gray-500 mt-1">
//                                                 <span className="mr-3">👤 {onlineVisitors}</span>
//                                                 <span>📊 {todayVisits}</span>
//                                             </div>
//                                         </div>
//                                         <button
//                                             onClick={() => leaveSite(siteKey)}
//                                             className="ml-2 p-1 hover:bg-red-100 rounded transition-colors opacity-0 group-hover:opacity-100"
//                                             title="Arrêter la surveillance"
//                                         >
//                                             <EyeOff className="h-3 w-3 text-red-500" />
//                                         </button>
//                                     </div>
//                                 );
//                             })}
//
//                             {siteData.monitoredCount > 5 && (
//                                 <div className="text-center pt-2 border-t border-gray-200">
//                                     <span className="text-xs text-gray-500">
//                                         +{siteData.monitoredCount - 5} autre{siteData.monitoredCount - 5 > 1 ? 's' : ''} site{siteData.monitoredCount - 5 > 1 ? 's' : ''} surveillé{siteData.monitoredCount - 5 > 1 ? 's' : ''}
//                                     </span>
//                                 </div>
//                             )}
//                         </div>
//                     ) : (
//                         <div className="text-center py-4 bg-gray-50 rounded-lg">
//                             <EyeOff className="h-8 w-8 text-gray-400 mx-auto mb-2" />
//                             <p className="text-sm text-gray-600 mb-3">
//                                 Aucun site n'est actuellement surveillé
//                             </p>
//                             {siteData.unmonitoredSites.length > 0 && (
//                                 <div className="space-y-2 mt-3">
//                                     {siteData.unmonitoredSites.slice(0, 3).map((site, index) => {
//                                         const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
//                                         const siteName = _.get(site, 'name', siteKey);
//
//                                         return (
//                                             <button
//                                                 key={`unmonitored-${siteKey}`}
//                                                 onClick={() => joinSite(siteKey)}
//                                                 className="w-full flex items-center justify-between p-2 bg-white border border-gray-200 hover:bg-blue-50 hover:border-blue-300 rounded-lg transition-all"
//                                             >
//                                                 <span className="text-sm text-gray-700 truncate">
//                                                     {_.truncate(siteName, { length: 20 })}
//                                                 </span>
//                                                 <Eye className="h-3 w-3 text-blue-500" />
//                                             </button>
//                                         );
//                                     })}
//                                     {siteData.unmonitoredSites.length > 3 && (
//                                         <p className="text-xs text-gray-500 mt-2">
//                                             +{siteData.unmonitoredSites.length - 3} autre{siteData.unmonitoredSites.length - 3 > 1 ? 's' : ''} site{siteData.unmonitoredSites.length - 3 > 1 ? 's' : ''} disponible{siteData.unmonitoredSites.length - 3 > 1 ? 's' : ''}
//                                         </p>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//
//                 {/* Visites récentes */}
//                 {safeRecentVisits.length > 0 && (
//                     <div className="mt-4 pt-4 border-t border-gray-200">
//                         <div className="flex items-center justify-between mb-3">
//                             <div className="flex items-center">
//                                 <Activity className="h-4 w-4 text-purple-600 mr-2" />
//                                 <span className="text-sm font-medium text-gray-900">
//                                     Visites récentes
//                                 </span>
//                             </div>
//                             <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
//                                 {safeRecentVisits.length}
//                             </span>
//                         </div>
//                         <div className="space-y-2 max-h-32 overflow-y-auto pr-2">
//                             {safeRecentVisits.slice(0, 5).map((visit, index) => {
//                                 const safeVisit = _.isObject(visit) ? visit : {};
//                                 const visitIp = _.get(safeVisit, 'ip', 'N/A');
//                                 const visitCity = _.get(safeVisit, 'city', 'Localisation inconnue');
//                                 const visitCountry = _.get(safeVisit, 'country', '');
//                                 const visitedAt = _.get(safeVisit, 'visitedAt');
//
//                                 let formattedTime = 'N/A';
//                                 if (visitedAt) {
//                                     try {
//                                         const date = new Date(visitedAt);
//                                         const now = new Date();
//                                         const diffMinutes = Math.floor((now - date) / (1000 * 60));
//
//                                         if (diffMinutes < 1) {
//                                             formattedTime = 'À l\'instant';
//                                         } else if (diffMinutes < 60) {
//                                             formattedTime = `Il y a ${diffMinutes} min`;
//                                         } else {
//                                             formattedTime = date.toLocaleTimeString([], {
//                                                 hour: '2-digit',
//                                                 minute: '2-digit'
//                                             });
//                                         }
//                                     } catch (error) {
//                                         console.warn('Erreur formatage date:', error);
//                                     }
//                                 }
//
//                                 const location = visitCountry ? `${visitCity}, ${visitCountry}` : visitCity;
//
//                                 return (
//                                     <div key={`visit-${index}-${visitIp}`}
//                                          className="flex items-center p-2 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors">
//                                         <div className="flex-1 min-w-0">
//                                             <p className="text-sm font-medium text-gray-900 truncate">
//                                                 {visitIp}
//                                             </p>
//                                             <p className="text-xs text-gray-500 truncate">
//                                                 {location}
//                                             </p>
//                                         </div>
//                                         <span className="text-xs text-gray-500 ml-2 whitespace-nowrap">
//                                             {formattedTime}
//                                         </span>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>
//                 )}
//                 <div className="mt-4">
//                     <button
//                         onClick={async () => {
//                             try {
//                                 await joinAllSites();
//                                 alert(`✅ ${sites.length} sites rejoints`);
//                             } catch (error) {
//                                 alert(`❌ Erreur: ${error.message}`);
//                             }
//                         }}
//                         className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg font-medium transition-colors flex items-center justify-center"
//                         disabled={!isConnected}
//                     >
//                         <Signal className="h-4 w-4 mr-2" />
//                         Rejoindre tous les sites ({siteData.totalCount})
//                     </button>
//                 </div>
//
//                 {/* Pied */}
//                 <div className="mt-4 pt-3 border-t border-gray-200">
//                     <div className="flex items-center justify-between text-xs text-gray-500">
//                         <span className="flex items-center">
//                             <div className={`h-2 w-2 rounded-full mr-2 ${isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`}></div>
//                             Socket.IO • {isConnected ? 'En ligne' : 'Hors ligne'}
//                         </span>
//                         <span>
//                             {isConnected && socketService && (
//                                 <span className="flex items-center">
//                                     <div className="h-2 w-2 rounded-full bg-blue-500 mr-1"></div>
//                                     {socketService.siteRooms?.size || 0} rooms
//                                 </span>
//                             )}
//                         </span>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import {
    Activity,
    AlertCircle,
    CheckCircle2,
    Eye,
    EyeOff,
    Globe,
    RefreshCw,
    Signal,
    Wifi,
    WifiOff,
    X,
    ChevronDown,
    ChevronUp,
    Zap
} from 'lucide-react';
import { useSocket } from "../dashboard/SocketContext.jsx";

export default function SocketStatus() {
    // Récupérer les sites depuis Redux
    const sites = useSelector(state => state.sites.items);
    const {
        isConnected,
        socketId,
        socketService,
        activeSites = new Set(),
        recentVisits = [],
        sendHeartbeat,
        joinAllSites
    } = useSocket();

    // État local
    const [isOpen, setIsOpen] = useState(true);
    const [isMinimized, setIsMinimized] = useState(false);
    const [showMonitored, setShowMonitored] = useState(true);
    const [showRecent, setShowRecent] = useState(true);

    // Sécuriser les valeurs avec lodash
    const safeActiveSites = _.isSet(activeSites) ? activeSites : new Set();
    const safeRecentVisits = _.isArray(recentVisits) ? recentVisits : [];
    const safeSocketId = _.isString(socketId) ? socketId : null;

    // Formater les données des sites
    const siteData = useMemo(() => {
        try {
            // Convertir les sites en tableau sécurisé
            const safeSites = _.isArray(sites) ? sites : [];

            // Filtrer pour ne garder que les sites avec surveillance active
            const monitoredSites = safeSites.filter(site => {
                const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
                return siteKey && safeActiveSites.has(siteKey);
            });

            // Sites non surveillés
            const unmonitoredSites = safeSites.filter(site => {
                const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
                return siteKey && !safeActiveSites.has(siteKey);
            });

            // Récupérer les noms des sites surveillés
            const monitoredSiteNames = monitoredSites.map(site =>
                _.get(site, 'name', _.get(site, 'siteKey', 'Site inconnu'))
            );

            return {
                monitoredCount: monitoredSites.length,
                totalCount: safeSites.length,
                monitoredSites: monitoredSites,
                unmonitoredSites: unmonitoredSites,
                monitoredSiteNames,
                onlineCount: _.sumBy(monitoredSites, site =>
                    _.toNumber(_.get(site, 'onlineVisitors', 0))
                )
            };
        } catch (error) {
            console.error('Erreur formatage sites:', error);
            return {
                monitoredCount: 0,
                totalCount: 0,
                monitoredSites: [],
                unmonitoredSites: [],
                monitoredSiteNames: [],
                onlineCount: 0
            };
        }
    }, [sites, safeActiveSites]);

    // Fonction pour joindre un site spécifique
    const joinSite = async (siteKey) => {
        if (socketService && socketService.joinSite) {
            try {
                await socketService.joinSite(siteKey);
            } catch (error) {
                console.error('Erreur rejoindre site:', error);
            }
        }
    };

    // Fonction pour quitter un site
    const leaveSite = async (siteKey) => {
        if (socketService && socketService.leaveSite) {
            try {
                socketService.leaveSite(siteKey);
            } catch (error) {
                console.error('Erreur quitter site:', error);
            }
        }
    };

    // Si fermé, afficher juste un bouton pour rouvrir
    if (!isOpen) {
        return (
            <div className="fixed bottom-4 right-4 z-50">
                <button
                    onClick={() => setIsOpen(true)}
                    className="flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white p-3 rounded-xl shadow-lg border border-blue-500 transition-all duration-300 hover:shadow-xl hover:scale-105"
                    title="Ouvrir le statut des sockets"
                >
                    <div className="relative">
                        <Wifi className="h-6 w-6" />
                        <div className={`absolute -top-1 -right-1 h-3 w-3 rounded-full ${isConnected ? 'bg-green-400' : 'bg-red-400'} animate-pulse`} />
                    </div>
                </button>
            </div>
        );
    }

    // Version minimisée
    if (isMinimized) {
        return (
            <div className="fixed bottom-4 right-4 z-50">
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                    <div className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-white">
                        <div className="flex items-center">
                            <div className={`p-1.5 rounded-full mr-2 ${isConnected ? 'bg-green-100' : 'bg-red-100'}`}>
                                {isConnected ? (
                                    <Wifi className="h-3 w-3 text-green-600" />
                                ) : (
                                    <WifiOff className="h-3 w-3 text-red-600" />
                                )}
                            </div>
                            <div className="flex items-center">
                                <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse mr-2" />
                                <span className="text-xs font-medium text-gray-700">
                  {siteData.monitoredCount}/{siteData.totalCount}
                </span>
                            </div>
                        </div>
                        <div className="flex items-center space-x-1">
                            <button
                                onClick={() => setIsMinimized(false)}
                                className="p-1 hover:bg-gray-100 rounded transition-colors"
                                title="Agrandir"
                            >
                                <ChevronUp className="h-3 w-3 text-gray-600" />
                            </button>
                            <button
                                onClick={() => setIsOpen(false)}
                                className="p-1 hover:bg-gray-100 rounded transition-colors"
                                title="Fermer"
                            >
                                <X className="h-3 w-3 text-gray-600" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Version complète
    return (
        <div className="fixed bottom-4 right-4 z-50 animate-fade-in-up">
            <div className="bg-white rounded-xl shadow-2xl border border-gray-300 p-4 w-80 max-h-[85vh] overflow-hidden flex flex-col backdrop-blur-sm bg-white/95">
                {/* En-tête avec boutons de contrôle */}
                <div className="flex items-center justify-between mb-3 pb-3 border-b border-gray-200">
                    <div className="flex items-center">
                        <div className={`p-2 rounded-full mr-3 ${isConnected ? 'bg-gradient-to-r from-green-100 to-green-50' : 'bg-gradient-to-r from-red-100 to-red-50'}`}>
                            {isConnected ? (
                                <Wifi className="h-5 w-5 text-green-600" />
                            ) : (
                                <WifiOff className="h-5 w-5 text-red-600" />
                            )}
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-900 text-sm">
                                Surveillance en temps réel
                            </h3>
                            <p className="text-xs text-gray-500">
                                {isConnected ? 'Connecté' : 'Déconnecté'}
                                {safeSocketId && (
                                    <span className="ml-2 font-mono">#{safeSocketId.substring(0, 4)}</span>
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center space-x-1">
                        <button
                            onClick={sendHeartbeat}
                            className="p-1.5 hover:bg-blue-50 rounded-lg transition-all duration-200 hover:rotate-180"
                            title="Tester la connexion"
                            disabled={!isConnected}
                        >
                            <RefreshCw className={`h-4 w-4 ${isConnected ? 'text-blue-600' : 'text-gray-400'} transition-transform`} />
                        </button>
                        <button
                            onClick={() => setIsMinimized(true)}
                            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                            title="Réduire"
                        >
                            <ChevronDown className="h-4 w-4 text-gray-600" />
                        </button>
                        <button
                            onClick={() => setIsOpen(false)}
                            className="p-1.5 hover:bg-red-50 rounded-lg transition-colors"
                            title="Fermer"
                        >
                            <X className="h-4 w-4 text-gray-600" />
                        </button>
                    </div>
                </div>

                {/* Contenu défilant */}
                <div className="flex-1 overflow-y-auto pr-1 space-y-4">
                    {/* État de connexion */}
                    <div className={`px-3 py-2 rounded-lg ${isConnected ? 'bg-gradient-to-r from-green-50 to-green-100 border border-green-200' : 'bg-gradient-to-r from-red-50 to-red-100 border border-red-200'}`}>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <div className={`h-3 w-3 rounded-full mr-2 ${isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`} />
                                <span className={`text-sm font-semibold ${isConnected ? 'text-green-800' : 'text-red-800'}`}>
                  {isConnected ? 'Connexion active' : 'Hors ligne'}
                </span>
                            </div>
                            {socketService?.siteRooms?.size > 0 && (
                                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-medium">
                  {socketService.siteRooms.size} rooms
                </span>
                            )}
                        </div>
                    </div>

                    {/* Statistiques de surveillance */}
                    <div className="grid grid-cols-2 gap-3">
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-3 border border-blue-200 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-blue-700 font-medium mb-1">Sites total</p>
                                    <p className="text-lg font-bold text-blue-900">
                                        {siteData.totalCount}
                                    </p>
                                </div>
                                <Globe className="h-5 w-5 text-blue-600 opacity-80" />
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-3 border border-green-200 shadow-sm">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs text-green-700 font-medium mb-1">Surveillés</p>
                                    <p className="text-lg font-bold text-green-900">
                                        {siteData.monitoredCount}
                                    </p>
                                </div>
                                <Eye className="h-5 w-5 text-green-600 opacity-80" />
                            </div>
                        </div>
                    </div>

                    {/* Bouton rejoindre tous */}
                    <button
                        onClick={async () => {
                            try {
                                await joinAllSites();
                            } catch (error) {
                                console.error('Erreur:', error);
                            }
                        }}
                        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-2 px-4 rounded-lg font-medium transition-all duration-300 flex items-center justify-center shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={!isConnected || siteData.totalCount === 0}
                    >
                        <Zap className="h-4 w-4 mr-2" />
                        Rejoindre tous ({siteData.totalCount})
                    </button>

                    {/* Sites surveillés */}
                    <div>
                        <div className="flex items-center justify-between mb-3">
                            <button
                                onClick={() => setShowMonitored(!showMonitored)}
                                className="flex items-center text-sm font-semibold text-gray-900 hover:text-blue-700 transition-colors"
                            >
                                <Globe className="h-4 w-4 mr-2 text-blue-600" />
                                Sites surveillés
                                <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                  {siteData.monitoredCount}/{siteData.totalCount}
                </span>
                            </button>
                            <div className="flex items-center">
                                <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse mr-1"></div>
                                <span className="text-xs text-gray-500">
                  {siteData.onlineCount} en ligne
                </span>
                            </div>
                        </div>

                        {showMonitored && (
                            siteData.monitoredCount > 0 ? (
                                <div className="space-y-2 max-h-60 overflow-y-auto pr-1">
                                    {siteData.monitoredSites.slice(0, 5).map((site, index) => {
                                        const siteKey = _.get(site, 'siteKey') || _.get(site, 'id');
                                        const siteName = _.get(site, 'name', siteKey);
                                        const onlineVisitors = _.toNumber(_.get(site, 'onlineVisitors', 0));
                                        const todayVisits = _.toNumber(_.get(site, 'todayVisites', 0));

                                        return (
                                            <div
                                                key={`monitored-${siteKey}-${index}`}
                                                className="flex items-center justify-between p-2.5 bg-gradient-to-r from-gray-50 to-white hover:from-blue-50 hover:to-blue-100 rounded-lg transition-all duration-200 group border border-gray-200 hover:border-blue-300"
                                            >
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center">
                                                        <Signal className="h-3.5 w-3.5 text-green-500 mr-2 flex-shrink-0" />
                                                        <span className="text-sm font-medium text-gray-900 truncate">
                              {_.truncate(siteName, { length: 22 })}
                            </span>
                                                    </div>
                                                    <div className="flex items-center text-xs text-gray-600 mt-1.5 space-x-3">
                            <span className="flex items-center">
                              <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-1.5" />
                                {onlineVisitors} en ligne
                            </span>
                                                        <span className="flex items-center">
                              <Activity className="h-3 w-3 mr-1.5" />
                                                            {todayVisits} aujourd'hui
                            </span>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => leaveSite(siteKey)}
                                                    className="ml-2 p-1.5 hover:bg-red-50 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100 hover:scale-110"
                                                    title="Arrêter la surveillance"
                                                >
                                                    <EyeOff className="h-3.5 w-3.5 text-red-500" />
                                                </button>
                                            </div>
                                        );
                                    })}

                                    {siteData.monitoredCount > 5 && (
                                        <div className="text-center pt-2 border-t border-gray-200">
                      <span className="text-xs text-gray-500">
                        +{siteData.monitoredCount - 5} autre{siteData.monitoredCount - 5 > 1 ? 's' : ''} site{siteData.monitoredCount - 5 > 1 ? 's' : ''}
                      </span>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border border-gray-200">
                                    <EyeOff className="h-8 w-8 text-gray-400 mx-auto mb-3 opacity-70" />
                                    <p className="text-sm text-gray-600 mb-2">
                                        Aucun site surveillé
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        Cliquez sur "Rejoindre tous" pour démarrer
                                    </p>
                                </div>
                            )
                        )}
                    </div>

                    {/* Visites récentes */}
                    {safeRecentVisits.length > 0 && (
                        <div>
                            <button
                                onClick={() => setShowRecent(!showRecent)}
                                className="flex items-center justify-between w-full mb-3"
                            >
                                <div className="flex items-center text-sm font-semibold text-gray-900 hover:text-purple-700 transition-colors">
                                    <Activity className="h-4 w-4 mr-2 text-purple-600" />
                                    Visites récentes
                                </div>
                                <span className="text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full font-medium">
                  {safeRecentVisits.length}
                </span>
                            </button>

                            {showRecent && (
                                <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
                                    {safeRecentVisits.slice(0, 4).map((visit, index) => {
                                        const safeVisit = _.isObject(visit) ? visit : {};
                                        const visitIp = _.get(safeVisit, 'ip', 'N/A');
                                        const visitCity = _.get(safeVisit, 'city', 'Localisation inconnue');
                                        const visitCountry = _.get(safeVisit, 'country', '');
                                        const visitedAt = _.get(safeVisit, 'visitedAt');

                                        let formattedTime = 'N/A';
                                        if (visitedAt) {
                                            try {
                                                const date = new Date(visitedAt);
                                                const now = new Date();
                                                const diffMinutes = Math.floor((now - date) / (1000 * 60));

                                                if (diffMinutes < 1) {
                                                    formattedTime = 'À l\'instant';
                                                } else if (diffMinutes < 60) {
                                                    formattedTime = `${diffMinutes} min`;
                                                } else {
                                                    formattedTime = date.toLocaleTimeString([], {
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    });
                                                }
                                            } catch (error) {
                                                console.warn('Erreur formatage date:', error);
                                            }
                                        }

                                        const location = visitCountry ? `${visitCity}, ${visitCountry}` : visitCity;

                                        return (
                                            <div
                                                key={`visit-${index}-${visitIp}`}
                                                className="flex items-center p-2.5 bg-gradient-to-r from-gray-50 to-white hover:from-purple-50 hover:to-purple-100 rounded-lg transition-all duration-200 border border-gray-200 hover:border-purple-300"
                                            >
                                                <div className="flex-1 min-w-0">
                                                    <p className="text-sm font-medium text-gray-900 truncate">
                                                        {visitIp}
                                                    </p>
                                                    <p className="text-xs text-gray-600 truncate">
                                                        {_.truncate(location, { length: 24 })}
                                                    </p>
                                                </div>
                                                <span className="text-xs font-medium text-purple-700 ml-2 whitespace-nowrap bg-purple-50 px-2 py-1 rounded">
                          {formattedTime}
                        </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Pied */}
                <div className="mt-4 pt-3 border-t border-gray-200">
                    <div className="flex items-center justify-between text-xs text-gray-500">
                        <div className="flex items-center">
                            <div className={`h-2 w-2 rounded-full mr-2 ${isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`}></div>
                            <span className="font-medium">
                Socket.IO • {isConnected ? 'En ligne' : 'Hors ligne'}
              </span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <div className="flex items-center">
                                <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-1"></div>
                                <span>{siteData.monitoredCount} actifs</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}